import React from 'react';
import logo from '../../../assets/logo.svg';

const SiderHeader = () => (
  <div className="SiderHeader">
    <img src={logo} alt="logo" />
    <h1>wTrips</h1>
  </div>
);

export default SiderHeader;
